import {Component, DoCheck, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";
import {Report} from "./report";

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css']
})
export class ReportComponent extends AppComponent implements OnInit, DoCheck {


    placeholder: any;

    service = this.reportService;
    tables = [];
    cols = [];

    ngDoCheck(): void {
        let model = new Report;
        let tables = model.tabela;
        if (model !== this.model) {
            this.placeholder = "select " + this.model.colunas +
                " from " + this.model.tabela +
                " Escreva os joins(EXEMPLO: INNER JOIN), condições(EXEMPLO: WHERE), grupos(EXEMPLO: GROUP BY) e ordem(EXEMPLO: ORDER BY) aqui";
        }
        // if (tables !== this.model.tabela) {
        //     this.service.getcols(this.model.tabela)
        //         .then(response => {
        //                 this.cols = response;
        //             }
        //         );
        // }


        super.ngDoCheck();
    }

	submit(report: Report): void {
		if (!this.model.tabela || !this.model.tabela.length)
			this.utils.exibirMensagem('É preciso escolher ao menos uma tabela!', 'danger');
		else if (!this.model.colunas || !this.model.colunas.length)
			this.utils.exibirMensagem('É preciso escolher ao menos uma coluna!', 'danger');
		else
			super.submit(report);
	}

    ngOnInit() {
        this.validar_login();
		if (this.isAdmin()) {
			this.model = new Report();
			this.service.gettables().then(response => {
				this.tables = this.set_dados(response);
			})
		} else
			this.router.navigateByUrl('inicio');	
    }

    getcols() {
		if (this.model.tabela && this.model.tabela.length > 0)
			this.service.getcols(this.model.tabela).then(response => {this.cols = this.set_dados(response);});
    }

    set_dados(dados) {

        let dataset = [];
        //Definir os dados
        for (let i = 0; i < dados.length; i++) {
            let remover;

            if (dados.length == 1) {
                dados.push(dados[i]);
                remover = true;
            }
            // get all object property names
            Object.keys(dados[1])
            // iterate over them and generate the array
                .map(function (k) {
                    dataset[i] = dados[i][k];
                });
            if (remover) {
                dados.splice(0, 1);
            }


        }
        return dataset;
    }


}



// WEBPACK FOOTER //
// ./src/app/report/report.component.ts